import { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useAiSearch } from 'api/hooks/use-ai-search'

const AiSearchBar = ({ dashboardId, params, setParams, onReferenceSearch, onClearAll, onClearReferences, onAnalyticSearch, onClearAnalytics }) => {
  const [query, setQuery] = useState('')
  const [message, setMessage] = useState(null)
  const [messageVariant, setMessageVariant] = useState('info')

  const { mutate, isLoading } = useAiSearch({
    dashboardId,
    options: {
      onSuccess: (data) => {
        if (data.clear_all) {
          if (onClearAll) onClearAll()
          setMessage(null)
          setQuery('')
        } else if (data.filters || data.reference_search || data.clear_references || data.analytic_search || data.clear_analytics) {
          if (data.filters && Object.keys(data.filters).length > 0) {
            setParams((prev) => {
              const next = { ...prev }
              Object.entries(data.filters).forEach(([key, value]) => {
                // Set to '' instead of deleting so the key flows through
                // to tableFilters and properly clears any stale filter values
                next[key] = (value === null) ? '' : value
              })
              return next
            })
          }
          if (data.clear_references && onClearReferences) {
            onClearReferences(data.clear_references)
          }
          if (data.reference_search && onReferenceSearch) {
            onReferenceSearch(data.reference_search)
          }
          if (data.analytic_search && onAnalyticSearch) {
            onAnalyticSearch(data.analytic_search)
          }
          if (data.clear_analytics && onClearAnalytics) {
            onClearAnalytics(data.clear_analytics)
          }
          setMessage(null)
          setQuery('')
        } else if (data.no_filters || data.info_request) {
          setMessageVariant('info')
          setMessage(data.message)
        }
      },
      onError: () => {
        setMessageVariant('danger')
        setMessage('Something went wrong. Please try again.')
      }
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!query.trim() || isLoading) return

    setMessage(null)
    mutate({ query: query.trim(), currentParams: params })
  }

  const handleClear = () => {
    setQuery('')
    setMessage(null)
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <InputGroup>
          <InputGroup.Text>
            <Badge className="badge-ai"><FontAwesomeIcon icon={faSearch} className="me-1" />AI</Badge>
          </InputGroup.Text>
          <FormControl
            type="text"
            placeholder='Try "Show transactions over $5,000 from last month"'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            disabled={isLoading}
          />
          {query && (
            <Button variant="light-primary" onClick={handleClear} disabled={isLoading}>
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          )}
          <Button type="submit" variant="primary" disabled={isLoading || !query.trim()}>
            {isLoading ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : (
              'Search'
            )}
          </Button>
        </InputGroup>
      </form>
      {message && (
        <Row className="mt-2">
          <Col>
            <Alert variant={messageVariant} dismissible onClose={() => setMessage(null)}>
              {message}
            </Alert>
          </Col>
        </Row>
      )}
    </>
  )
}

export default AiSearchBar
